import RegistryForm from '@/features/RegistryForm/RegistryForm.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RegistryView',
  components: {
    RegistryForm,
  },
  setup() {
    return {}
  },
})
